import {styled, Table as MuiTable, TableBody, TableCell as MuiTableCell, TableRow} from "@mui/material";
import {formatCompanyName} from "../utils/DataGridUtils";

const Table = styled(MuiTable)(() => ({
    marginLeft: "4rem",
}));

const TableCell = styled(MuiTableCell)(() => ({
    border: "none",
    padding: "0 1.3rem 0 0",
}));

const AwardsDataGridDetailPanel = ({row}) => {
    return (
        <Table size="small">
            <TableBody>
                <TableRow>
                    <TableCell align="right" width="140px">Name at time of deal:</TableCell>
                    <TableCell>{formatCompanyName(row.settlementName)}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align="right">Increase Type:</TableCell>
                    <TableCell>{row.increaseType}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align="right">Long Term Deal:</TableCell>
                    <TableCell>{row.longTermDeal ? "Yes" : "No"}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align="right">Union Recognised:</TableCell>
                    <TableCell>{row.unionRecognised ? "Yes" : "No"}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align="right">Unions:</TableCell>
                    <TableCell>{row.unionDetails}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align="right">Sector:</TableCell>
                    <TableCell>{row.sectorName}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align="right">Industry:</TableCell>
                    <TableCell>{row.industryName}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align="right">Subsector:</TableCell>
                    <TableCell>{row.subSectorName}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
};

export default AwardsDataGridDetailPanel;
